import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-v2-footer',
    templateUrl: './v2-footer.component.html',
    styleUrls: ['./v2-footer.component.scss'],
    standalone: false
})
export class V2FooterComponent implements OnInit {

  constructor() { }

  currentYear: number = (new Date()).getFullYear()

  ngOnInit(): void {
    return;
  }

}

